import { useAvailableServices } from '@/hooks/useAvailableServices';
import { useGeoDataMyIp } from '@/hooks/useGeoDataMyIp';
import { useUserData } from '@/services/getUserData';
import { IBooking } from '@/services/types/booking/details';
import { IBookingService } from '@/services/types/booking/services';
import { EProtections } from '@/services/types/core/protections';

const usCountryCode = 'US';

export const useTripProtectionService = (
  booking?: IBooking | null,
  userId?: number,
): { service?: IBookingService; isEligible: boolean; isLoading: boolean } => {
  const geoDataResponse = useGeoDataMyIp();
  const userDataResponse = useUserData(userId);
  const availableServicesResponse = useAvailableServices(booking?.id, {
    weather: booking?.can_generate_weather_quote?.toString() || 'false',
  });

  if (!booking || !availableServicesResponse.data) {
    return { service: undefined, isEligible: false, isLoading: true };
  }

  const userIsEligible =
    geoDataResponse.data?.country_code === usCountryCode ||
    userDataResponse.data?.data?.bank_country === usCountryCode ||
    userDataResponse.data?.data?.profile?.address?.country === usCountryCode;

  const tripProtectionServiceData = availableServicesResponse.data?.find(
    service => service.category === EProtections.TRIP_INSURANCE,
  );
  const canAddTripProtection = tripProtectionServiceData
    ? tripProtectionServiceData.total > 0
    : false;

  return {
    service: tripProtectionServiceData,
    isEligible: userIsEligible && canAddTripProtection,
    isLoading:
      geoDataResponse.isLoading ||
      userDataResponse.isLoading ||
      availableServicesResponse.isLoading,
  };
};
